// extracted by mini-css-extract-plugin
export default {"input":"FileUploadMenuItem-module__input--8Fe3u"};